import { ProfileDropdown } from 'components/dropdownFilters/ProfileDropdown';
import HttpService from 'services/HttpServiceBasic';
import { trackAction } from '../../helpers/trackingOM';
import { FALLBACK_AVATAR } from 'vue/FormConfig';
import { getLocale } from 'services/LocalizationService';
import { kidsBadgeAsset, kidsAvatarAsset, addProfilePicAsset } from 'shared/userProfileAvatars';

export class CarouselProfileDropdown {
    constructor() {
        this.kidsBadge = kidsBadgeAsset;
        this.kidsAvatar = kidsAvatarAsset;
        this.addProfilePic = addProfilePicAsset;
        this.maxOtherProfileCount = 5;
        this.keepWatchingCarouselTitle = getLocale('keep_watching_for', { 'profile Name': '' });
        this.myListCarouselTitle = getLocale('my_list_for', { 'profile Name': '' });
    }

    getUserProfile() {
        const http = new HttpService();
        const profilesUrl = '/user-profile/xhr/user/';
        return http.doGet(profilesUrl, {});
    }

    addDropDown(isKeepWatching, isMyList, carouselId) {
        this.getUserProfile().then((response) => {
            if (response?.success && response?.profiles.length > 0) {
                // active profile
                let options = [
                    {
                        title: response.activeProfile.name,
                        value: 1,
                        pic: response.activeProfile.profilePicPath,
                    },
                ];
                // other profiles
                const otherProfiles = response?.profiles
                    .filter((profile) => {
                        return response.activeProfile.id !== profile.id;
                    })
                    .map((profile, index) => {
                        return {
                            title: profile.name,
                            value: index,
                            pic: profile.profilePicPath ?? FALLBACK_AVATAR,
                            id: profile.id,
                        };
                    });
                //other actions
                const otherActions =
                    otherProfiles.length < this.maxOtherProfileCount
                        ? [
                              {
                                  title: getLocale('add_kids_profile'),
                                  value: -2,
                                  kidsBadge: this.kidsBadge,
                                  pic: this.kidsAvatar,
                              },
                              {
                                  title: getLocale('add_profile'),
                                  value: -3,
                                  customClass: 'scaled',
                                  pic: this.addProfilePic,
                              },
                          ]
                        : [];
                options = [...options, ...otherProfiles, ...otherActions];
                this.dropDown = new ProfileDropdown(options, response);
                const carouselWrapper = document.querySelector(`#${carouselId}`);
                const dropDownContainer = carouselWrapper?.querySelector(`.js-dropdown`);
                const carouselContainer = carouselWrapper?.querySelector(`.js-video-carousel`);

                if (dropDownContainer) {
                    this.dropDown.setMount($(dropDownContainer)).setSelectedIndex(0).build();
                    carouselWrapper.classList.add('has-profile-dropdown');
                    dropDownContainer.classList.add('initialized');
                    carouselContainer.classList.add('initialized');
                    if (isKeepWatching || isMyList) {
                        const carouselTitle = isKeepWatching
                            ? this.keepWatchingCarouselTitle
                            : this.myListCarouselTitle;
                        const carouselTitleElement = carouselContainer.querySelector('h2');
                        carouselTitleElement.innerHTML = carouselTitle;
                    }
                    const dropDownEl = dropDownContainer.querySelector('.pv-h');
                    this.#addDropdownListener(dropDownEl);
                }
            }
        });
    }

    #addDropdownListener(element) {
        // Observes when the hover class is added to the dropdown element,
        // which causes the dropdown to show, then track the action
        const dropDownToggleClassObserver = new MutationObserver((mutation) => {
            if (mutation[0]?.oldValue === 'pv-h') {
                const parentCarousel =
                    mutation[0].target.parentElement.parentElement.querySelector(
                        '.video-section-title',
                    );
                const headerTitle = parentCarousel.textContent.trimStart().trimEnd();
                trackAction('trackCarouselDropDown', {
                    rowHeaderTitle: headerTitle,
                });
            }
        });
        dropDownToggleClassObserver.observe(element, {
            attributeFilter: ['class'],
            attributeOldValue: true,
            subtree: false,
        });
    }
}
